import { useBackend } from "../../services";
import { StatusCodesHelper } from "../../models/StatusCodesHelper";
import { ImageCache } from "../../models/ImageCache";

export const useUploadFrontImageFromDiscogs = () => {
  const { post } = useBackend();
  const uploadFrontImageFromDiscogs = async (albumUuid: string) => {
    const { status, body } = await post("albums/uploadImageFromDiscogs", { uuid: albumUuid });
    if (StatusCodesHelper.isSuccessful(status)) {
      await ImageCache.shared.removeImage(
        `${albumUuid}_${ImageCache.bigAlbumImageSize}_${ImageCache.bigAlbumImageSize}`
      );
      await ImageCache.shared.removeImage(
        `${albumUuid}_${ImageCache.smallAlbumImageSize}_${ImageCache.smallAlbumImageSize}`
      );
    }
    return { status, body };
  };
  return { uploadFrontImageFromDiscogs };
};
